import { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";

import LocalOfferIcon from "@mui/icons-material/LocalOffer";

import { IUnitsInformation } from "../type";
import { useConfig } from "../../../context/ConfigProvider";

export const Promotion: FC<IUnitsInformation> = (props) => {
  const {configuration} = useConfig();
  const promotion = props.discountPlans.find((x) => x.autoApply);
  

  return promotion && Boolean(promotion.publicDescription) ? (
    <Box
      sx={(theme) => ({
        width: "100%",
        p: 0.25,
        backgroundColor: alpha(configuration.themification.colors.secondary, 0.1),
        color: configuration.themification.colors.secondary,
        flexDirection: theme.direction === "ltr" ? "row" : "row-reverse",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        fontSize: theme.typography.pxToRem(15),
      })}
    >
      <LocalOfferIcon fontSize="inherit" sx={{ m: 0.5 }} />
      <Typography variant="subtitle2" fontSize="inherit">
        {promotion.publicDescription}
      </Typography>
    </Box>
  ) : null;
};
